import { Injectable } from '@angular/core';

export interface FieldHistoryState {
  history: any[];
  redoStack: any[];
}

@Injectable({
  providedIn: 'root',
})
export class CourseAiFieldHistoryService {
  private historyMap = new Map<string, FieldHistoryState>();

  getHistory(id: string): FieldHistoryState | null {
    if (!id) return null;
    const state = this.historyMap.get(id);
    if (!state) return null;
    return {
      history: this.deepClone(state.history),
      redoStack: this.deepClone(state.redoStack),
    };
  }

  saveState(id: string, history: any[], redoStack: any[]): void {
    if (!id) return;
    this.historyMap.set(id, {
      history: this.deepClone(history),
      redoStack: this.deepClone(redoStack),
    });
  }

  hasHistory(id: string): boolean {
    if (!id) return false;
    return this.historyMap.has(id);
  }

  clearHistory(id?: string): void {
    if (id) {
      this.historyMap.delete(id);
    } else {
      this.historyMap.clear();
    }
  }

  private deepClone(obj: any): any {
    try {
      return JSON.parse(JSON.stringify(obj));
    } catch {
      return obj;
    }
  }
}
